import * as React from 'react';
import { IProps as ITopProps } from 'ui/apps/PI';

export type ViewType = React.SFC<ITopProps> | React.ComponentType<ITopProps>;

export interface IApps {
  active: boolean;
  name: string;
  displayName: string;
  icon: string;
  component: ViewType;
  testId: string;
  priority: number;
}

export const AppsList: IApps[] = [
  {
    active: true,
    name: 'summary',
    displayName: 'Clinical Data',
    icon: 'assignment_ind',
    component: React.lazy(() => import('ui/apps/Clinical')),
    testId: 'sidebar__clinical',
    priority: 1,
  },
  {
    active: true,
    name: 'profile',
    displayName: 'Profile',
    icon: 'account_circle',
    component: React.lazy(() => import('ui/apps/PI')),
    testId: 'sidebar__pi',
    priority: 2,
  },
];

export const Apps: IApps[] = AppsList.filter(e => e.active).sort((a, b) => a.priority - b.priority);

export const filterSortVisible = (apps: IApps[], visibleApps: string) => {
  const visibleAppsList = visibleApps
    .trim()
    .split(',')
    .map(e => e.trim())
    .filter(e => !!e.length);
  return apps
    .filter(app => visibleAppsList.indexOf(app.name) > -1 && app.active)
    .sort((a, b) => a.priority - b.priority);
};

export const getApps = (visibleApps: string) => {
  return filterSortVisible(AppsList, visibleApps);
};
